module.exports = __webpack_public_path__ + "img/match--type1_img3--sp.a84489d6.png";